module.exports = __webpack_public_path__ + "static/ywbl3-10d5f52a8630b5c5e84c43ec57ab253f.jpg";